import { DEFAULT_SESSION_ID } from "../constants";

export const forgotPasswordActions = {

    FETCH_FORGOTPWD_FAILED: 'FETCH_FORGOTPWD_FAILED',
    FETCH_FORGOTPWD_SUCCESS: 'FETCH_FORGOTPWD_SUCCESS',
    FETCH_FORGOTPWD_PENDING: 'FETCH_FORGOTPWD_PENDING',
    FORGOT_PASSWORD: 'FORGOT_PASSWORD',
    CHANGE_PASSWORD: 'CHANGE_PASSWORD',
    VERIFY_PASSWORD_CHANGE_CODE: 'VERIFY_PASSWORD_CHANGE_CODE',
    VALIDATE_INVITATION_TOKENS: 'VALIDATE_INVITATION_TOKENS',
    RESET_PASSWORD_WITH_TOKENS: 'RESET_PASSWORD_WITH_TOKENS',
    RESET_STATE: 'RESET_STATE',

    fetchForgotPasswordFailed: error => ({
        type: forgotPasswordActions.FETCH_FORGOTPWD_FAILED,
        payload: { error }
    }),

    fetchForgotPasswordSuccess: (userId, data) => ({
        type: forgotPasswordActions.FETCH_FORGOTPWD_SUCCESS,
        payload: {
            data,
            userId
        }
    }),

    fetchForgotPasswordPending: userId => ({
        type: forgotPasswordActions.FETCH_FORGOTPWD_PENDING,
        payload: {
            userId
        }
    }),


    forgotResetPassword: data => ({
        type: forgotPasswordActions.FORGOT_PASSWORD,
        payload: {
            data,
            userId: DEFAULT_SESSION_ID
        }
    }),

    changePassword: data => ({
        type: forgotPasswordActions.CHANGE_PASSWORD,
        payload: {
            data,
            userId: DEFAULT_SESSION_ID
        }
    }),

    verifyPasswordChangeCode: data => ({
        type: forgotPasswordActions.VERIFY_PASSWORD_CHANGE_CODE,
        payload: {
            data,
            userId: DEFAULT_SESSION_ID
        }
    }),

    validateInvitationTokens: data => ({
        type: forgotPasswordActions.VALIDATE_INVITATION_TOKENS,
        payload: {
            data,
            userId: DEFAULT_SESSION_ID
        }
    }),

    resetPasswordWithTokens: data => ({
        type: forgotPasswordActions.RESET_PASSWORD_WITH_TOKENS,
        payload: {
            data,
            userId: DEFAULT_SESSION_ID
        }
    }),

    resetState: () => ({
        type: forgotPasswordActions.RESET_STATE,
    })
};


export const forgotPasswordRequestActions = {
    failed: forgotPasswordActions.fetchForgotPasswordFailed,
    success: forgotPasswordActions.fetchForgotPasswordSuccess,
    pending: forgotPasswordActions.fetchForgotPasswordPending
};
